import FooterDefaultStyle from '@/styles/components/careers/footer/_index.module.scss';
import TwitterIcon from 'public/icons/career_icons/social_icons/twitter.svg';
import FacebookIcon from 'public/icons/career_icons/social_icons/facebook.svg';
import LinkedinIcon from 'public/icons/career_icons/social_icons/linkedin.svg';
import InstagramIcon from 'public/icons/career_icons/social_icons/instagram.svg';
import YoutubeIcon from 'public/icons/career_icons/social_icons/youtube.svg';
import { LINK_TYPES, CommonAction, useTranslation } from '@/imports-files/pages/career/customize-career-page';


export function Footer({formik, customizeCareerAction, isPreview, footerClass})
{
  const {t} = useTranslation()
  const footerLinks = formik.values.career_navigation_links_attributes.filter((navigation) => !navigation._destroy && (navigation.navigation_type == LINK_TYPES.footer))
  const socialLink = formik.values.career_social_link_attributes
  const commonAction = new CommonAction();
  const footer_link_with_name = footerLinks.filter((x) => x.name).length
  const social_with_name = socialLink?.twitter_url || socialLink?.facebook_url || socialLink?.linkedin_url || socialLink?.instagram_url || socialLink?.youtube_url || ''
  return(
    <>
      {(social_with_name.length > 0 || footer_link_with_name > 0) && <div className = {`${FooterDefaultStyle.Footer} ${footerClass}`}>
        {footer_link_with_name > 0 && <div className = {`${FooterDefaultStyle.Footer__SocialIcons} ${social_with_name.length == 0 ? FooterDefaultStyle.Footer__LinksCenter : FooterDefaultStyle.Footer__Links}`}>
          <ul>
            {footerLinks.map((footerLink, index) => {
              return (footerLink.name && <li key={`f_link_${index}`}
              >
              {footerLink.url ? <a style={customizeCareerAction.headerStyle(formik)} href = {commonAction.addHttpOrHttps(footerLink.url)} target={"_blank"}>{footerLink.name}</a> : <a style={customizeCareerAction.headerStyle(formik)}>{footerLink.name}</a>}
            </li>)
            }
            )}
          </ul>
        </div>}

        {social_with_name.length > 0 && <div className = {`${FooterDefaultStyle.Footer__Right} ${footer_link_with_name > 0 ? FooterDefaultStyle.Footer__SocialIconsRight : FooterDefaultStyle.Footer__SocialIconsCenter}`}>
          <ul>
            {socialLink?.twitter_url && <li key={'twitter_url_f'} className = {`${FooterDefaultStyle.Footer__Links__Li}`}>
              <a href = {commonAction.addHttpOrHttps(socialLink.twitter_url)} target={"_blank"}><TwitterIcon/></a>
            </li>}
            {socialLink?.facebook_url && <li key={'facebook_url_f'} className = {`${FooterDefaultStyle.Footer__Links__Li}`}>
              <a href = {commonAction.addHttpOrHttps(socialLink.facebook_url)} target={"_blank"}><FacebookIcon/></a>
            </li>}
            {socialLink?.linkedin_url && <li key={'linkedin_url_f'} className = {`${FooterDefaultStyle.Footer__Links__Li}`}>
              <a href = {commonAction.addHttpOrHttps(socialLink.linkedin_url)} target={"_blank"}><LinkedinIcon/></a>
            </li>}
           {socialLink?.instagram_url &&  <li key={'instagram_url_f'} className = {`${FooterDefaultStyle.Footer__Links__Li}`}>
              <a href = {commonAction.addHttpOrHttps(socialLink.instagram_url)} target={"_blank"}><InstagramIcon/></a>
            </li>}
            {socialLink?.youtube_url &&  <li key={'youtube_url_f'} className = {`${FooterDefaultStyle.Footer__Links__Li}`}>
              <a href = {commonAction.addHttpOrHttps(socialLink.youtube_url)} target={"_blank"}><YoutubeIcon/></a>
            </li>}
          </ul>
        </div>}
      </div>}
      <div className = {`${FooterDefaultStyle.Footer__Disclaimer}`}>
        <p>{t('jobs:hiring_with')}</p>
        <img src = "/images/logo/Full-logo-default.svg"></img>
      </div>
    </>
  )
}